import { theme } from '@factorialco/deprecated-design-system'
import { ThemeAPI } from '@ingestro/importer-react'

export const sheetSelect: ThemeAPI['sheetSelect'] = {
  root: {
    backgroundColor: theme.colors.grey000White,
    border: `${theme.border.width.s1} ${theme.border.style.solid} ${theme.colors.grey400}`,
  },
  pageHeader: {
    root: {
      backgroundColor: theme.colors.grey000White,
    },
    title: {
      fontSize: theme.fontSizes[300],
    },
    description: {
      fontSize: theme.fontSizes[200],
    },
  },
  header: {
    color: theme.colors.grey800,
  },
  sheetName: {
    root: {
      backgroundColor: theme.colors.grey100,
    },
    title: {
      color: theme.colors.grey1000,
    },
    description: {
      color: theme.colors.grey800,
    },
    border: {
      backgroundColor: theme.colors.radicalRed600,
    },
  },
  grid: {
    container: {
      background: theme.colors.grey000White,
    },
    root: {
      backgroundColor: theme.colors.grey100,
    },
    title: {
      color: theme.colors.grey1000,
    },
    description: {
      color: theme.colors.grey800,
    },
    checkbox: {
      backgroundColor: theme.colors.grey100,
    },
    illustration: {
      borderColor: theme.colors.grey800,
      cellColor: theme.colors.grey100,
      headerColor: theme.colors.radicalRed600,
      outlineColor: theme.colors.grey100,
    },
    checked: {
      root: {
        borderColor: theme.colors.grey1000,
        backgroundColor: theme.colors.grey400,
      },
      title: {
        color: theme.colors.grey1000,
      },
      description: {
        color: theme.colors.grey800,
      },
      checkbox: {
        backgroundColor: `${theme.colors.radicalRed600} !important`,
        borderColor: `${theme.colors.radicalRed800} !important`,
      },
      illustration: {
        borderColor: theme.colors.grey800,
        cellColor: `${theme.colors.radicalRed100} !important`,
        headerColor: theme.colors.radicalRed600,
        outlineColor: `${theme.colors.radicalRed100} !important`,
      },
    },
  },
  list: {
    root: {
      backgroundColor: theme.colors.grey100,
      borderColor: theme.colors.grey600,
    },
    title: {
      color: theme.colors.grey1000,
    },
    description: {
      color: theme.colors.grey800,
    },
    checkbox: {
      backgroundColor: theme.colors.grey000White,
    },
    checked: {
      root: {
        borderColor: theme.colors.grey400,
        backgroundColor: theme.colors.grey200,
      },
      title: {
        color: theme.colors.grey1000,
      },
      description: {
        color: theme.colors.grey800,
      },
      checkbox: {
        backgroundColor: `${theme.colors.radicalRed600} !important`,
        borderColor: `${theme.colors.radicalRed800} !important`,
      },
    },
  },
  pagination: {
    currentPageButton: {
      backgroundColor: theme.colors.grey800,
      color: theme.colors.grey000White,
    },
  },
  icon: {
    stroke: theme.colors.grey1000,
  },
  sheetLists: {
    root: {
      backgroundColor: theme.colors.grey000White,
    },
  },
  scrollbar: {
    backgroundColor: theme.colors.grey100,
    navigatorColor: theme.colors.grey600,
  },
  unSelectSheetName: {
    root: {
      backgroundColor: theme.colors.grey000White,
    },
    title: {
      color: theme.colors.grey800,
    },
    description: {
      color: theme.colors.grey700,
    },
    border: {
      backgroundColor: theme.colors.grey000White,
    },
  },
  addFileButton: {
    root: {
      backgroundColor: theme.colors.grey100,
      color: theme.colors.grey800,
    },
    icon: {
      stroke: theme.colors.grey1000,
    },
  },
  sheetPreview: {
    title: {
      color: theme.colors.grey1000,
    },
    fileName: {
      color: theme.colors.grey800,
    },
    sheetName: {
      color: theme.colors.radicalRed800,
    },
    listButton: {
      color: theme.colors.grey800,
    },
    gridButton: {
      color: theme.colors.grey800,
    },
    table: {
      root: {
        background: theme.colors.grey400,
      },
      th: {
        color: theme.colors.radicalRed800,
      },
      td: {
        color: theme.colors.grey800,
      },
    },
  },
}
